import { checkIfAllowed } from '../../utils/restrictionFile';
import PrivacyStatement from '../../common/PrivacyStatement';
import { env } from '../../env';
import {
  roleRestricted,
  AD,
  SA,
  PC,
} from '../../components/RoleRestricted/utils';

export const returnNavlinks = (history, role, t) => {
  if (!role) return [];

  const projectsLink = {
    label: t('appBar.navigation.projectsTab'),
    href: '/',
  };

  const approvalLink = {
    label: 'Approval',
    href: '/approval',
  };

  const archiveLink = {
    label: t('appBar.navigation.archiveTab'),
    href: '/archive',
  };

  const financialFramesLink = {
    label: t('appBar.navigation.financialFramesTab'),
    href: '/financial-frames',
  };

  if (roleRestricted([PC, AD], role)) return [projectsLink, archiveLink];

  return [projectsLink, approvalLink, financialFramesLink, archiveLink];
};

export const returnUserObject = (user, t) => {
  if (!user) return null;
  return {
    given_name: user?.name?.split(' ')[0],
    family_name: user?.name?.split(' ')[1],
    jobTitle: t(`roles.${user?.expansionUserRole}`),
    primarySite: user?.email,
    picture: `https://ui-avatars.com/api/?name=${user.name}&background=random`,
  };
};
const linkPressed = (e, href, history) => {
  e.preventDefault();
  history.push(href);
};
export const returnSettingsMenu = (role, permissions: string[], history, t) => {
  let settings = [];
  if (roleRestricted([AD, SA], role)) {
    settings.push({
      key: 'admin-link',
      title: t('navigation.manageUsers'),
      href: '/admin-page',
      onClick: (e) => {
        linkPressed(e, '/admin-page', history);
      },
    });
  }
  if (checkIfAllowed(permissions, 'currency')) {
    settings = [
      {
        key: 'currency-link',
        title: t('navigation.manageCurrency'),
        href: '/currency-page',
        onClick: (e) => {
          linkPressed(e, '/currency-page', history);
        },
      },
      ...settings,
    ];
  }
  return settings;
};

export const returnSections = (t) => {
  const privacySection = {
    title: t('privacy.title'),
    template: <PrivacyStatement />,
  };
  return [privacySection];
};
export const applications = [
  {
    label: 'CAPEX',
    href: `externalhttps://${env.REACT_APP_RELTP_LINK}`,
    acronym: 'CPX',
  },
  {
    label: 'INVEX',
    href: `externalhttps://invex.ingka.com/ `,
    acronym: 'IE',
  },
  {
    label: 'VAXA',
    href: `externalhttps://vaxa.ingka.com/ `,
    acronym: 'V',
  },
  {
    label: 'PBI',
    href: 'externalhttps://app.powerbi.com/Redirect?action=OpenApp&appId=bb4619d2-d9ef-4a05-992e-d11e1365bf4e&ctid=720b637a-655a-40cf-816a-f22f40755c2c&experience=power-bi',
    acronym: 'PBI',
  },
  {
    label: 'Business Contribution',
    href: 'externalhttps://invex.ingka.com/vcg/',
    acronym: 'BC',
  },
];
